import React, { useRef, useState } from "react";
import * as IoIcons from "react-icons/io";
import "../estilos.css";
import { Row, Label, odal, ModalHeader, ModalBody, ModalFooter, Modal, Button } from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import QRGenerator from "../codereader/Qrgenerator";
import { useReactToPrint } from "react-to-print";
import { decodificarTextoJSON, ObtenerDCargaPProduccion, ObtenerDInspeccionFPProduccion, ObtenerDPintadoPProduccion } from "../queries/DCUbicaciones";

function DetallesProduccion({
  sProduccion,
  tipo,
  bColor,
  btitle,
}) {

  const [detallesCarga, setDetallesCarga] = useState([]);
  const [detallesPintado, setDetallesPintado] = useState([]);
  const [detallesInspeccionF, setDetallesInspeccionF] = useState([]);
  const [detallesCargaPowder, setDetallesCargaPowder] = useState([]);
  const [detallesPintadoPowder, setDetallesPintadoPowder] = useState([]);
  const [detallesInspeccionFPowder, setDetallesInspeccionFPowder] = useState([]);
  const [modal3, setModal3] = useState(false);
  const [cargando, setCargando] = useState(false);
  const toggle3 = () => setModal3(!modal3);


  async function verDetalles(produccion) {
    setCargando(true);
    const datosCarga = produccion.registroCarga ? await decodificarTextoJSON(produccion.registroCarga) : [];
    const datosPintado = produccion.registroPintado ? await decodificarTextoJSON(produccion.registroPintado) : [];
    const datosInspeccionF = produccion.registroInspeccionF ? await decodificarTextoJSON(produccion.registroInspeccionF) : [];
    const datosCargaPowder = produccion.registroCargaPC ? await decodificarTextoJSON(produccion.registroCargaPC) : [];
    const datosPintadoPowder = produccion.registroPintadoPC ? await decodificarTextoJSON(produccion.registroPintadoPC) : [];
    const datosInspeccionFPowder = produccion.registroInspeccionFPC ? await decodificarTextoJSON(produccion.registroInspeccionFPC) : [];

    /*const datosCarga = produccion.registroCarga ?
      await ObtenerDCargaPProduccion(produccion.registroCarga) : [];*/
    setDetallesCarga(datosCarga);
    /*const datosPintado = produccion.registroPintado ?
      await ObtenerDPintadoPProduccion(produccion.registroPintado) : [];*/
    setDetallesPintado(datosPintado);
    /*const datosInspeccionF = produccion.registroInspeccionF ?
      await ObtenerDInspeccionFPProduccion(produccion.registroInspeccionF) : [];*/
    setDetallesInspeccionF(datosInspeccionF);
    //Datos de Powder
    setDetallesCargaPowder(datosCargaPowder);
    setDetallesPintadoPowder(datosPintadoPowder);
    setDetallesInspeccionFPowder(datosInspeccionFPowder);

    toggle3();
    setCargando(false);

  }

  function obtenerUltimaUbicaciont(ubicacion) {
    var uUbicacion = "";
    var uLocacion = "";
    var uCantidad = "";
    var uEspacio = "";
    return <>
      <Table className="bordersubtabla">
        <Thead>
          <Tr>
            <Th className="subtablah bordersubtabla">Ubic.</Th>
            <Th className="subtablah bordersubtabla">Loc.</Th>
            <Th className="subtablah bordersubtabla">Pzs.</Th>
            <Th className="subtablah bordersubtabla">Esp.</Th>
          </Tr>
        </Thead>
        <Tbody>
          {ubicacion && (
            <>
              {ubicacion.map(x => (
                uUbicacion = x.substr(1, x.search(',') - 1).replace('ubicacion=', ''),
                uLocacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
                uCantidad = x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', ''),
                uEspacio = x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search('}') - 1).replace('espacio=', ''),
                <Tr>
                  <Td className="bordersubtabla">{uUbicacion}</Td>
                  <Td className="bordersubtabla">{uLocacion}</Td>
                  <Td className={uLocacion ? "bordersubtabla" : "margintopmobil20px bordersubtabla"}>{uCantidad}</Td>
                  <Td className="bordersubtabla">{uEspacio != 0 ? uEspacio : "--"}</Td>
                </Tr>

              ))}
            </>)}
        </Tbody>
      </Table>
    </>
  }

  return (
    <>
      <Row>
        {cargando === true && (
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
            <img width="150px" src="assets/img/preloader.gif" />
          </div>
        )}
      </Row>
      {cargando === false && (
        <button
          class={"btn-" + bColor + " cbutton"}
          title={btitle}
          //style={{ display: "none" }}
          onClick={() => verDetalles(sProduccion)}
        >
          <IoIcons.IoIosListBox />
        </button>
      )}
      <Modal isOpen={modal3} toggle={toggle3} size="xl" >
        <ModalHeader toggle={toggle3}>
          Detalles
        </ModalHeader>
        <ModalBody>
          <Row>
            <div className={" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
              <h5 class=""> Datos generales</h5>
              <Table className="mb-2 scroll ">
                <Thead class="thead-secondary">
                  <Tr>
                    <Th className="minwidth200px">Cliente</Th>
                    <Th className="minwidth100px">Número de parte</Th>
                    <Th className="minwidth100px">Descripción</Th>
                    <Th>Serial</Th>
                    <Th className="minwidth100px">Serial BTI</Th>
                    <Th>Proceso</Th>
                    <Th>Cantidad Recibida</Th>
                    <Th>Estatus de Incoming</Th>
                    <Th className="minwidth100px ">Cantidad planeada</Th>
                    <Th className="minwidth100px ">Material en planta</Th>
                    <Th className="minwidth100px ">Última ubicación</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr >
                    <Td className="margintopmobil20px">{sProduccion.cliente}</Td>
                    <Td className="margintopmobil20px">{sProduccion.numerodeParte}</Td>
                    <Td className="margintopmobil20px">{sProduccion.descripcion}</Td>
                    <Td className="margintopmobil20px">{sProduccion.serial}</Td>
                    <Td className="margintopmobil20px">{sProduccion.serialRecibaBTI}</Td>
                    <Td className="margintopmobil20px">
                      <Label>{(sProduccion.Ecoat === true || (!sProduccion.Ecoat && sProduccion.precioUnitario)) ? "Ecoat" : ""}</Label>
                      <Label className="mt-1">{sProduccion.Pcoat === true ? "Powder coat" : ""}</Label>
                      {/*<Label className="mt-1">{sProduccion.Platinado === true ? "Platinado" : ""}</Label>*/}
                    </Td>
                    <Td className="margintopmobil20px">{sProduccion.cantidadRecibida} </Td>
                    <Td className="margintopmobil20px">{sProduccion.status} </Td>
                    <Td className="margintopmobil20px">{sProduccion.cantidadPlaneada} </Td>
                    <Td className="margintopmobil20px">{sProduccion.piezasEnPlanta ? "Sí" : "No"} </Td>
                    <Td className="margintopmobil20px">{obtenerUltimaUbicaciont(
                      sProduccion.ultimaUbicacion
                    )} </Td>
                  </Tr>
                </Tbody>
              </Table>
            </div>
          </Row>
          {(sProduccion.Ecoat === true || (!sProduccion.Ecoat && sProduccion.precioUnitario)) && (
            <>
              <Row>
                <div className={detallesCarga.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                  " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                  <h5 class=""> Datos de carga Ecoat</h5>
                  <Table className="mb-2 scroll ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th >No.</Th>
                        <Th >Fecha</Th>
                        <Th >Hora</Th>
                        <Th >Cantidad</Th>
                        <Th>Número de rack</Th>
                        <Th>Tipo de rack</Th>
                        <Th>Racks </Th>
                        <Th>Ciclos</Th>
                        <Th >Usuario  </Th>
                        <Th >Módulo </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {detallesCarga.map((carga, i) => (
                        (!carga.activo ? true : carga.activo === "true" ? true : false) && (
                          <Tr className={i % 2 !== 0 ? "table-active " : ""}>
                            <Td className="">{i + 1}</Td>
                            <Td className="margintopmobil20px">{carga.fecha}</Td>
                            <Td className="margintopmobil20px">{carga.hora}</Td>
                            <Td className="margintopmobil20px">{carga.piezasenCarga}</Td>
                            <Td className="margintopmobil20px">{carga.numeroRackCarga}</Td>
                            <Td className="margintopmobil20px">{(carga.rackTipo && carga.rackTipo != "null") ? carga.rackTipo : ""}</Td>
                            <Td className="margintopmobil20px">{carga.racks}</Td>
                            <Td className="margintopmobil20px">{carga.ciclos} </Td>
                            <Td className="margintopmobil20px">{carga.Reg_Ins_Usuario} </Td>
                            <Td className={carga.modulo ? "margintopmobil20px" : "margintopmobil20px mb-4"}>{carga.modulo}</Td>
                          </Tr>)
                      ))}
                    </Tbody>
                  </Table>
                </div>
              </Row>
              <Row>
                <div className={detallesPintado.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                  " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                  <h5 class="margintop10px"> Datos de pintado Ecoat</h5>
                  <Table className="mb-2 scroll ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th >No.</Th>
                        <Th >Fecha</Th>
                        <Th >Hora</Th>
                        <Th >Cantidad</Th>
                        {/*<Th>Racks </Th>
                    <Th>Ciclos</Th>*/}
                        <Th >Usuario  </Th>
                        <Th >Módulo </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {detallesPintado.map((pintado, i) => (
                        (!pintado.activo ? true : pintado.activo === "true" ? true : false) && (
                          <Tr className={i % 2 !== 0 ? "table-active " : ""}>
                            <Td className="">{i + 1}</Td>
                            <Td className="margintopmobil20px">{pintado.fecha}</Td>
                            <Td className="margintopmobil20px">{pintado.hora}</Td>
                            <Td className="margintopmobil20px">{pintado.piezasenPintado}</Td>
                            {/*<Td className="margintopmobil20px">{pintado.racks}</Td>
                      <Td className="margintopmobil20px">{pintado.ciclos} </Td>*/}
                            <Td className="margintopmobil20px">{pintado.Reg_Ins_Usuario} </Td>
                            <Td className={pintado.modulo ? "margintopmobil20px" : "margintopmobil20px mb-4"} >{pintado.modulo}</Td>
                          </Tr>
                        )
                      ))}
                    </Tbody>
                  </Table>
                </div>
              </Row>
              <Row>
                <div className={detallesInspeccionF.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                  " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                  <h5 class="margintop10px"> Datos de Inspección final Ecoat</h5>
                  <Table className="mb-2 scroll ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th >No.</Th>
                        <Th >Fecha</Th>
                        <Th >Hora</Th>
                        <Th >Piezas aceptadas</Th>
                        <Th>Piezas no aceptadas </Th>
                        <Th>Defecto</Th>
                        <Th>Número de rack</Th>
                        <Th>Comentarios</Th>
                        <Th >Usuario  </Th>
                        <Th >Módulo </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {detallesInspeccionF.map((inspeccionF, i) => (
                        (!inspeccionF.activo ? true : inspeccionF.activo === "true" ? true : false) && (
                          <Tr className={i % 2 !== 0 ? "table-active " : ""}>
                            <Td className="">{i + 1}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.fecha}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.hora}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.piezasAceptadas}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.piezasNoAceptadas ? inspeccionF.piezasNoAceptadas : ""}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.defecto ? inspeccionF.defecto : inspeccionF.pnaotroDefecto} </Td>
                            <Td className="margintopmobil20px">{inspeccionF.numeroRackCarga} </Td>
                            <Td className="margintopmobil20px">{inspeccionF.comentariosInspeccion} </Td>
                            <Td className="margintopmobil20px">{inspeccionF.Reg_Ins_Usuario} </Td>
                            <Td className={inspeccionF.modulo ? "margintopmobil20px" : "margintopmobil20px mb-4"}>{inspeccionF.modulo}</Td>

                          </Tr>
                        )
                      ))}
                    </Tbody>
                  </Table>
                </div>
              </Row>
            </>
          )}
          {(sProduccion.Pcoat === true) && (
            <>
              <Row>
                <div className={detallesCargaPowder.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                  " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                  <h5 class=""> Datos de carga Powder Coat</h5>
                  <Table className="mb-2 scroll ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th >No.</Th>
                        <Th >Fecha</Th>
                        <Th >Hora</Th>
                        <Th >Cantidad</Th>
                        <Th>Número de rack</Th>
                        <Th>Tipo de rack</Th>
                        <Th>Racks </Th>
                        <Th>Ciclos</Th>
                        <Th >Usuario  </Th>
                        <Th >Módulo </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {detallesCargaPowder.map((carga, i) => (
                        (!carga.activo ? true : carga.activo === "true" ? true : false) && (
                          <Tr className={i % 2 !== 0 ? "table-active " : ""}>
                            <Td className="">{i + 1}</Td>
                            <Td className="margintopmobil20px">{carga.fecha}</Td>
                            <Td className="margintopmobil20px">{carga.hora}</Td>
                            <Td className="margintopmobil20px">{carga.piezasenCarga}</Td>
                            <Td className="margintopmobil20px">{carga.numeroRackCarga}</Td>
                            <Td className="margintopmobil20px">{(carga.rackTipo && carga.rackTipo != "null") ? carga.rackTipo : ""}</Td>
                            <Td className="margintopmobil20px">{carga.racks}</Td>
                            <Td className="margintopmobil20px">{carga.ciclos} </Td>
                            <Td className="margintopmobil20px">{carga.Reg_Ins_Usuario} </Td>
                            <Td className={carga.modulo ? "margintopmobil20px" : "margintopmobil20px mb-4"}>{carga.modulo}</Td>
                          </Tr>)
                      ))}
                    </Tbody>
                  </Table>
                </div>
              </Row>
              <Row>
                <div className={detallesPintadoPowder.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                  " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                  <h5 class="margintop10px"> Datos de pintado Powder Coat</h5>
                  <Table className="mb-2 scroll ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th >No.</Th>
                        <Th >Fecha</Th>
                        <Th >Hora</Th>
                        <Th >Cantidad</Th>
                        {/*<Th>Racks </Th>
                    <Th>Ciclos</Th>*/}
                        <Th >Usuario  </Th>
                        <Th >Módulo </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {detallesPintadoPowder.map((pintado, i) => (
                        (!pintado.activo ? true : pintado.activo === "true" ? true : false) && (
                          <Tr className={i % 2 !== 0 ? "table-active " : ""}>
                            <Td className="">{i + 1}</Td>
                            <Td className="margintopmobil20px">{pintado.fecha}</Td>
                            <Td className="margintopmobil20px">{pintado.hora}</Td>
                            <Td className="margintopmobil20px">{pintado.piezasenPintado}</Td>
                            {/*<Td className="margintopmobil20px">{pintado.racks}</Td>
                      <Td className="margintopmobil20px">{pintado.ciclos} </Td>*/}
                            <Td className="margintopmobil20px">{pintado.Reg_Ins_Usuario} </Td>
                            <Td className={pintado.modulo ? "margintopmobil20px" : "margintopmobil20px mb-4"} >{pintado.modulo}</Td>
                          </Tr>
                        )
                      ))}
                    </Tbody>
                  </Table>
                </div>
              </Row>
              <Row>
                <div className={detallesInspeccionFPowder.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                  " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                  <h5 class="margintop10px"> Datos de Inspección final Powder Coat</h5>
                  <Table className="mb-2 scroll ">
                    <Thead class="thead-secondary">
                      <Tr>
                        <Th >No.</Th>
                        <Th >Fecha</Th>
                        <Th >Hora</Th>
                        <Th >Piezas aceptadas</Th>
                        <Th>Piezas no aceptadas </Th>
                        <Th>Defecto</Th>
                        <Th>Número de rack</Th>
                        <Th>Comentarios</Th>
                        <Th >Usuario  </Th>
                        <Th >Módulo </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {detallesInspeccionFPowder.map((inspeccionF, i) => (
                        (!inspeccionF.activo ? true : inspeccionF.activo === "true" ? true : false) && (
                          <Tr className={i % 2 !== 0 ? "table-active " : ""}>
                            <Td className="">{i + 1}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.fecha}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.hora}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.piezasAceptadas}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.piezasNoAceptadas ? inspeccionF.piezasNoAceptadas : ""}</Td>
                            <Td className="margintopmobil20px">{inspeccionF.defecto ? inspeccionF.defecto : inspeccionF.pnaotroDefecto} </Td>
                            <Td className="margintopmobil20px">{inspeccionF.numeroRackCarga} </Td>
                            <Td className="margintopmobil20px">{inspeccionF.comentariosInspeccion} </Td>
                            <Td className="margintopmobil20px">{inspeccionF.Reg_Ins_Usuario} </Td>
                            <Td className={inspeccionF.modulo ? "margintopmobil20px" : "margintopmobil20px mb-4"}>{inspeccionF.modulo}</Td>

                          </Tr>
                        )
                      ))}
                    </Tbody>
                  </Table>
                </div>
              </Row>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggle3}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
export default DetallesProduccion;
